import { render } from "./ChangeOtp.vue?vue&type=template&id=a788fdca&scoped=true"
import script from "./ChangeOtp.vue?vue&type=script&lang=js"
export * from "./ChangeOtp.vue?vue&type=script&lang=js"

import "./ChangeOtp.vue?vue&type=style&index=0&id=a788fdca&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a788fdca"]])

export default __exports__